/**
 * Generic URL codec for comma-separated multi-select search params.
 *
 * A selection travels as one comma-separated param (e.g. `?experience=a,b`)
 * rather than repeated keys or an array. A single string keeps the React
 * Query key stable — the whole filters object is the cache key, so an array
 * literal would produce a fresh key on every render.
 */

/** Reads a comma-separated search param into a selection. Unset means "all". */
export function parseCsvParam(raw: string | undefined | null): Array<string> {
  if (!raw) return []
  const seen = new Set<string>()
  for (const part of raw.split(',')) {
    const value = part.trim()
    if (value) seen.add(value)
  }
  return Array.from(seen)
}

/**
 * Writes a selection back to a comma-separated search param. An empty
 * selection returns undefined so the param drops out of the URL entirely.
 */
export function serializeCsvParam(
  values: ReadonlyArray<string>,
): string | undefined {
  return values.length > 0 ? values.join(',') : undefined
}
